import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import WinnersCard from "./WinnersCard";
import { Trophy } from "lucide-react";



const CurrentMonthWinner = () => {

  return (
    <HeaderComponent
      title="October 2025 Winners"
      description="This month's outstanding value champions"
      icon={<Trophy className="w-6 h-6 text-white"/>}
      colorTheme="gradient orange !rounded-full"
      descriptionClass="text-sm muted-text"
      cardBorder="border border-amber-200 dark:border-amber-700 bg-gradient-to-br from-white to-amber-50 dark:from-white/10 dark:to-amber-900"
    >
      <div >
        <WinnersCard/>
      </div>
   </HeaderComponent>
  );
};

export default CurrentMonthWinner;
